export function NgLoadingDirective() {
  return {
    restrict: 'A',
    template: '<span class="loading-spiner"></span>'
  };
}
